import React from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import Label from '../../atoms/label/label';
import TextEditor from '../../atoms/textEditor/textEditor';

const FormTextEditor = (props) => {
  const {
    validation,
    label,
    helpText,
    value,
    onChange,
    toolbar
  } = props;

  return (
    <div className={`form-group row text-${validation}`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8">
        <TextEditor
          toolbar={toolbar}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

FormTextEditor.propTypes = {
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.string,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
};

FormTextEditor.defaultProps = {
  validation: FormValidation.PENDING,
  label: '',
  helpText: '',
  value: '',
  onChange: () => {},
};

export default FormTextEditor;
